/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * DatePicker Footer styled
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.10.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';

export const DatePickerFooterStyled = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    padding-top: 24px;

    &:before {
        position: absolute;
        display: inline-block;
        top: 0;
        width: 100%;
        border-top: 1px solid ${colors.borderColorDisabled};
        content: "";
    }
`;

export const DatePickerFooterItemStyled = styled.div.attrs({
    'data-name': 'date-picker-footer-btn',
})`
    border-bottom: 1px dashed ${colors.ColorLink};
    cursor: pointer;
    ${fonts.textLink};
`;
